<template>
  <div class="dashboard-container">
    <a-row :gutter="20" class="message">
      <a-col :span="isDesktop ? 16 : 24">
        <a-card v-if="!empty(message)" :title="message.message">
          <div>
            <h2 v-text="$t('label.viewMessage')"></h2>
          </div>
          <div>
            <h3>
              <span class="font-noraml">{{ $t('label.subject') }}:</span>
              {{ message.subject }}
            </h3>
            <h5>
              <span class="font-noraml">{{ $t('label.from') }}:</span>
              {{ message.email }}
            </h5>
          </div>
        </a-card>
        <div v-else>
          <a-card>
            <a-tag color="red" v-if="!empty(errorMessage)">{{ errorMessage }}</a-tag>
          </a-card>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { empty } from '@/utils';
import { mapState } from 'vuex';
import UserService from '@/services/UserService';
export default {
  data: () => ({
    message: {},
    errorMessage: '',
  }),
  async created() {
    try {
      const resp = await UserService.getMessageInfo(this.$route.params.id);
      this.message = resp[0];
      if (empty(this.message)) {
        this.errorMessage = 'Message not found';
      }
    } catch (error) {
      this.errorMessage = error;
      console.error({ error });
    }
  },
  computed: {
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  methods: {
    empty,
  },
};
</script>
<style lang="scss">
.dashboard-container.content-page {
  padding: 0 !important;
  .message {
    padding: 20px;
    .ant-card {
      display: flex;
      flex-direction: column-reverse;
      .ant-card-head {
        border-top: 1px solid #e8e8e8;
        &-title {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
